import React from 'react';
import { Link } from 'react-router-dom';
import HomePageSlider from './HomePageSlider';
import ClientsCarousel from './ClientsCarousel';

const HomePage = () => {

    return (
        <>
            <HomePageSlider></HomePageSlider>
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-5">
                            <div className="about-img-holder">
                                <div className="about-img"><img className="img-fluid" src="./assets/images/banners/technology.avif" alt="about Image" />
                                </div>
                            </div>
                            {/* <!-- End .about-img-holder--> */}
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="heading heading-11">
                                <div className="row">
                                    <div className="col-12">
                                        <p className="heading-with-border">Welcome to Octopuss India </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <p className="octo-para">
                                            Octopuss India is a premier ISO 9001:2015 Certified  Company, provides wide range of Security Services, Manpower Services, House-Keeping Services, Ratail Services, Infrastructure  services, Event Services and Jobs related services. It includes – Armed & Unarmed Manned Guarding Services, Cash Van Service, Bouncer & Bodyguard Service, Event Management, Skilled & Unskilled Manpower Service, Temporary Staffing, Facility Management ans Housekeeping Services.
                                        </p>
                                        <p className="octo-para">
                                            We are the best guards service provider company in India. We are passionate about our work and truly believe in offering best of services to our clients at the most affordable cost. We continuously upgrade and improve ourselves to give you best in security. Our philosophy is giving “Security beyond Guarding” experience to our clients. We truly believe that Security is much more than mere deployment and monitoring of guards. It involves thorough identification of roles and responsibilities of each guard and providing training to enable them to perform their duties in most efficient and productive manner. We aim to make your investment on security more productive by supplementing security guard responsibilities with important roles in the best interest of the company and with an aim to relieve the management completely of security and all allied problems. Our security guard service is most sought after services in India.
                                        </p>
                                        <div className="about-action"><Link to="/About-Us"> <a className="btn btn--secondary">Read More... <i className="icon-arrow-right"></i></a></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End .col-lg-6 --> */}
                    </div>
                    {/* <!-- End .row--> */}
                </div>
                {/* <!-- End .container--> */}
            </section>

            {/* <!-- Count Area Start --> */}
            <div className="bleezy-count-area" style={{ paddingTop: '30px', paddingBottom: '30px', marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="counts-text">
                                <h5 className='count-pare-heading'>We are ready to provide security in resonable price and guarantee your safety in any situation in your life </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h5 className="counter count-pare-heading">300+</h5>
                                <h6 className='count-pare-heading-content'>Satified<span>Clients</span></h6>
                            </div>
                        </div> */}
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter counter count-pare-heading">200+</h3>
                                <h4 className='count-pare-heading-content'>Satified Clients</h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter counter count-pare-heading">98%</h3>
                                <h4 className='count-pare-heading-content'>Retention  <span>Rate</span></h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter counter count-pare-heading">900+</h3>
                                <h4 className='count-pare-heading-content'>Manpower </h4>
                            </div>
                        </div>
                        <div className="col-md-2 col-sm-2">
                            <div className="count-box">
                                <h3 className="counter counter count-pare-heading">100%</h3>
                                <h4 className='count-pare-heading-content'>Compliance</h4>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="count-box">
                                <h3 className="counter counter count-pare-heading">5</h3>
                                <h4 className='count-pare-heading-content'>Business Verticals</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Count Area End --> */}

            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row">

                        <div className="col-12 col-lg-12">
                            <div className="heading heading-11">
                                <div className="row" style={{ display: 'flex' }}>
                                    <div className='center-heading'>
                                        <p className="heading-with-border">Our Services </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <p className="octo-para">
                                            Octopuss India is a trusted name in the field of recruitment and HR solutions, headquartered in Kolkata, India. With a vision to connect the right talent with the right opportunities, we specialize in delivering customized staffing solutions to businesses across various industries including IT, Non-IT, Healthcare, Education, Retail, FMCG, and more.
                                        </p>
                                        <p className="octo-para">
                                            Established with a strong commitment to excellence and integrity, Octopuss India operates on a simple principle — to understand the unique hiring needs of every client and provide fast, effective, and reliable manpower solutions.
                                            Whether you're a startup or a well-established enterprise, our experienced team of recruiters is equipped to support all your hiring goals with precision.
                                        </p>
                                    </div>
                                </div>
                                {/* <div className="row"> */}
                                {/* <div className="services-section"> */}
                                    <div className="services-grid">

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/wedding-couple1.png" className="service-icon" />
                                            <h3>WEDDINGS</h3>
                                            <p>Impeccable Planning to Flawless Execution</p>
                                        </div>

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/new-product.png" className="service-icon" />
                                            <h3>PRODUCT LAUNCH</h3>
                                            <p>Turning Ideas into Unforgettable Launches</p>
                                        </div>

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/manager.png" className="service-icon" />
                                            <h3>ARTIST MANAGEMENT</h3>
                                            <p>Bringing Stars to Your Stage, Effortlessly</p>
                                        </div>

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/exhibition.png" className="service-icon" />
                                            <h3>EXHIBITIONS & TRADE SHOWS</h3>
                                            <p>Your Vision, Our Exhibition Expertise</p>
                                        </div>

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/festival.png" className="service-icon" />
                                            <h3>MUSIC FESTIVAL</h3>
                                            <p>Soundtrack to Your Perfect Music Festival</p>
                                        </div>

                                        <div className="service-card-new">
                                            <img src="./assets/images/home/sound-system.png" className="service-icon" />
                                            <h3>SOUND SYSTEM, & LIGHTING</h3>
                                            <p>Setting the Stage for Sensational Sound & Lighting</p>
                                        </div>

                                    </div>
                                    {/* </div> */}
                                {/* </div> */}
                                <div className="row">
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/jobs.avif" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS JOBS</h3>
                                            </div>

                                            <p className="service-text">
                                                Octopuss India is a trusted name in the field of recruitment and HR solutions, headquartered in Kolkata...
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/technology.avif" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS TECHNOLOIES</h3>
                                            </div>

                                            <p className="service-text">
                                                When you choose Octopus Technologies as your web development partner, you're choosing a commitment to...
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/background/1.jpg" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS EVENTS</h3>
                                            </div>

                                            <p className="service-text">
                                                Octopuss Events is a  360°  full service event & celebrity management firm with over Twelve Years of Co...
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/clietns.avif" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS RETAILS</h3>
                                            </div>

                                            <p className="service-text">
                                                Hire Professional Escort Guard for safeguarding your female employees during commuting at night in compliance...
                                            </p>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/infratructure.avif" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS INFRATRUCTURE</h3>
                                            </div>

                                            <p className="service-text">
                                                Hire Professional Escort Guard for safeguarding your female employees during commuting at night in compliance...
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/security.avif" alt="Security Guard" />
                                                <h3 className="service-title">OCTOPUSS SECURITY</h3>
                                            </div>

                                            <p className="service-text">
                                                Hire professional, trained and well build Bouncers and Bodyguard for your short term or long term security needs...
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="./assets/images/banners/facility.avif" alt="Security Guard" />
                                                <h3 className="service-title">FACILITY MANAGEMENT SYSTEM</h3>
                                            </div>

                                            <p className="service-text">
                                                Octopuss India is a professionally managed facility management service company based in Allahabad and...
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-sm-3">
                                        <div className="service-card single-gallery-img card-homep-page">
                                            <div className="service-image">
                                                <img src="assets/images/vision/vision.jpeg" alt="Security Guard" />
                                                <h3 className="service-title">Made2Klean</h3>
                                            </div>

                                            <p className="service-text">
                                                Made2Klean is a professional cleaning and maintenance service provider committed to delivering spotl...
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- End .col-lg-6 --> */}
                    </div>
                    {/* <!-- End .row--> */}
                </div>
                {/* <!-- End .container--> */}
            </section>

            <section className="why-trust-section">
                <div className="trust-container">

                    <h2 className="trust-title">
                        <p className="heading-with-border">Proven track record of success: See why 200+ clients trust us for results. </p>
                    </h2>

                    <ul className="trust-list">
                        <li>
                            <div className="custom-check"></div>
                            26 + Years Experience In the Industry
                        </li>

                        <li>
                            <div className="custom-check"></div>
                            Experience & Trained Employees and Work Force
                        </li>

                        <li>
                            <div className="custom-check"></div>
                            100% Statutory Compliant
                        </li>

                        <li>
                            <div className="custom-check"></div>
                            Serving 450 + Client Locations
                        </li>

                        <li>
                            <div className="custom-check"></div>
                            A Diverse portfolio of services
                        </li>

                        <li>
                            <div className="custom-check"></div>
                            Trusted by Prominent Business Groups and Leading Banks, Financial Institutions & Corporates For Over 2 Decades.
                        </li>
                    </ul>

                </div>
            </section>
            <section className="why-choose-section">
                <h2 className="title">WHY CHOOSE US?</h2>

                <div className="why-container">
                    {/* <!-- Box 1 --> */}
                    <div className="why-box">
                        <div className="icon">
                            <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="Ownership Icon" />

                        </div>
                        <h3>Ownership</h3>
                        <p>We believe in taking the ownership in our client's work.</p>
                    </div>

                    {/* <!-- Box 2 --> */}
                    <div className="why-box">
                        <div className="icon">
                            <img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" alt="Innovative Icon" />
                        </div>
                        <h3>Innovative</h3>
                        <p>We courageously experiment to bring new and satisfied HR solutions.</p>
                    </div>

                    {/* <!-- Box 3 --> */}
                    <div className="why-box">
                        <div className="icon">
                            <img src="https://cdn-icons-png.flaticon.com/512/1250/1250626.png" alt="Client Satisfaction Icon" />
                        </div>
                        <h3>Client Satisfaction</h3>
                        <p>At every step, we do an evaluation to achieve the satisfaction level.</p>
                    </div>

                    {/* <!-- Box 4 --> */}
                    <div className="why-box">
                        <div className="icon">
                            <img src="https://cdn-icons-png.flaticon.com/512/1040/1040230.png" alt="Confidence Icon" />
                        </div>
                        <h3>Confidence</h3>
                        <p>Confidence comes with knowledge and we strive to stay upgraded with latest trends.</p>
                    </div>
                </div>
            </section>
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px', marginBottom: '30px' }}>
                <div className="container">
                    <div className='row center-heading'>
                        <div className='center-heading'>
                            <p className="heading-with-border">Our happy clients </p>
                        </div>
                    </div>
                    <ClientsCarousel />
                </div>
            </section>

        </>
    )
}

export default HomePage;